// extracted by mini-css-extract-plugin
export default {"container":"MediaSection_container__Kegeg","header":"MediaSection_header__SqOL3","icon":"MediaSection_icon__pFBc1","content":"MediaSection_content__X+HrC"};